const setNumberOfPresentationPages = (state, payload) => {
  state.numbers.numberOfPresentationPages = payload
}

const setNumberOfLoadedPresentationPages = (state, payload) => {
  state.numbers.numberOfLoadedPresentationPages = payload
}

const setNumberOfPresentations = (state, payload) => {
  state.numbers.numberOfPresentations = payload
}

export default {
  setNumberOfPresentationPages,
  setNumberOfLoadedPresentationPages,
  setNumberOfPresentations,
}
